export const FLAG_GETTING_DRIVER_CONTRACT_TYPES =
  'FLAG_GETTING_DRIVER_CONTRACT_TYPES';
export const GET_DRIVER_CONTRACT_TYPES = 'GET_DRIVER_CONTRACT_TYPES';
export const CLEAR_DRIVER_CONTRACT_TYPES = 'CLEAR_DRIVER_CONTRACT_TYPES';
export const FLAG_DRIVER_CONTRACT_TYPE_ACTIVITY =
  'FLAG_DRIVER_CONTRACT_TYPE_ACTIVITY';
export const GET_DRIVER_CONTRACT_TYPE = 'GET_DRIVER_CONTRACT_TYPE';
export const CLEAR_DRIVER_CONTRACT_TYPE = 'CLEAR_DRIVER_CONTRACT_TYPE';
